<div class="content">
    <!-- Begin dashboard -->
    <div class="container-fluid" style="max-height: 860px;">
        <!-- Page Heading -->
        <div class="row">
            <div class="col d-flex align-items-center justify-content-between mb-4">
                <h1 class="dashboard-title">Payer</h1>
            </div>
        </div>

        <!-- Content Row -->
        <div class="row">
            <!--<div class="col-12  d-flex align-items-center justify-content-between">-->
                <!-- Search Box -->
              <div class="col-lg-9 col-md-8 pt-3 pb-1">
                <div class="google-search-container">

                  <i class="fa fa-search search-icon"></i>

                  <input
                    (keyup)="handleKeyUp($event)"
                    #searchBox
                    class="google-search-input"
                    type="text"
                    placeholder="Search payers..."
                  />

                  <i
                    *ngIf="searchBox.value"
                    class="fa fa-times clear-icon"
                    (click)="clearSearch(searchBox)"
                  ></i>

                </div>
              </div>


              <!-- Filter and Add Buttons -->
                <div class="col-lg-3 col-md-4 pt-3 pb-1 d-flex justify-content-end">
                    <!--<div class="btn-group btn-group-toggle" data-toggle="buttons">
                        <button class="btn btn-success" style="background-color: #8bc34a" (click)="_fetchData(2)">
                            Active
                        </button>
                        <button class="btn btn-danger" (click)="_fetchData(3)"> Inactive</button>
                        <button class="btn btn-secondary active" (click)="_fetchData(1)"> All</button>
                    </div>&nbsp;&nbsp;-->
                    <button [disabled]="!this.authService.hasRole('payer-edit')" class="btn btn-primary" type="button" routerLink="add" title="Add Patient">
                        <i class="fas fa-plus"></i>&nbsp; Add Payer
                    </button>
                </div>
            <!--</div>-->

            <!-- Table -->
            <div class="col-12">
                    <div class="table-panel p-4">
                        <div class="table-responsive table-scroll-x">
                            <table class="table table-sm" matSort (matSortChange)="sortData($event)">
                                <thead>
                                <tr>
                                    <th scope="col">Sr.No</th>
                                    <th mat-sort-header="name" scope="col">Name</th>
                                    <th mat-sort-header="email" scope="col">Payer-Code</th>
                                    <th scope="col">Action</th>
                                </tr>
                                </thead>
                                <tbody *ngFor="let table of tableData| filter: searchText; let i = index">
                                <tr>
                                    <th scope="row">{{i + 1}}</th>
                                    <td><a [routerLink]="this.authService.hasRole('payer-edit') ? ['details/', table.id]:null">{{table?.name ?  table.name : '-'}}</a></td>
                                    <td>{{table.payerIdCode ? table.payerIdCode : '-'}}</td>
                                    <td>
                                      <a
                                        title="Edit"
                                        [routerLink]="['details/', table.id]"
                                        [class.disabled]="!authService.hasRole('payer-edit')"
                                        [attr.tabindex]="authService.hasRole('payer-edit') ? null : -1"
                                        (click)="authService.hasRole('payer-edit') ? null : $event.preventDefault()"
                                      >
                                        <i class="fa-solid fa-user-pen"></i>
                                      </a>
                                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

                                      <a
                                        title="Delete"
                                        (click)="authService.hasRole('payer-edit') ? deleteEntry(table.id) : $event.preventDefault()"
                                        [class.disabled]="!authService.hasRole('payer-edit')"
                                        [attr.tabindex]="authService.hasRole('payer-edit') ? null : -1"
                                      >
                                        <i class="fa-regular fa-trash-can text-danger"></i>
                                      </a>
                                    </td>
                                </tr>
                                </tbody>
                                <tbody *ngIf="tableData == null || tableData.length == 0">
                                <tr>
                                    <td colspan="7" class="text-center"> No record found !</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <div *ngIf="tableData?.length !== 0" class="d-flex justify-content-end mt-3">
                            <mat-paginator
                                    [length]="totalRecord"
                                    [pageIndex]="pagination.currentPage"
                                    [pageSize]="pagination.size"
                                    [pageSizeOptions]="[5, 10, 25, 100]"
                                    aria-label="Select page"
                                    showFirstLastButtons
                                    color="warn"
                                    (page)="pageChange($event)">
                            </mat-paginator>
                        </div>
                    </div>
            </div>
        </div>
    </div>
</div>

